/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, DraggablePositionType, Text } from '@components/atoms'
import { PdfDraggableView } from './PdfDraggableView'

import { SignPositionType, SignPositionTargetType } from '../PdfReader'
import { useAppSelector } from '@redux/index'
import { deepPurple, grey } from '@mui/material/colors'
import { SignPositionOffsetType } from '@schemas'

interface PropsType {
	mode: 'none' | 'add' | 'update' | 'sign'
	onStop: (e: DraggablePositionType) => void
	onSubmit: () => any
	onClose: () => void
	positionOffset?: { x: number; y: number; page: number; disabled: boolean }
	showSignature?: boolean
	onSignatureClick?: () => void
	currentPage: number
	onSetting: () => void
}

export const DraggableSignaturePosition = (props: PropsType) => {
	const { mode, onStop, onClose, currentPage } = props

	// redux state
	const selectedPosition: SignPositionOffsetType[] =
		mode === 'sign'
			? useAppSelector(state => state.contract.selectedContractPosition)
			: useAppSelector(state => state.salesContractMgmt.selectedContractPosition)
	const signPosition: SignPositionType = useAppSelector(
		state => state.salesContractMgmt.signPosition,
	)

	// state
	const [isSetting, setIsSetting] = React.useState<boolean>(false)

	// variables
	const positionIdx = selectedPosition.findIndex(aPosition => aPosition.id === 'sign')
	const positionOffset: SignPositionOffsetType = selectedPosition[positionIdx]

	React.useEffect(() => {
		setIsSetting(true)
	}, [])

	React.useEffect(() => {
		if (mode === 'update') {
			setIsSetting(false)
		} else if (mode === 'add') {
			setIsSetting(true)
		} else {
			setIsSetting(true)
		}
	}, [mode])

	const onSetting = () => {
		setIsSetting(true)
		props.onSetting()
	}

	const onSubmit = () => {
		setIsSetting(false)
		props.onSubmit()
	}

	return (
		<PdfDraggableView
			onStop={onStop}
			onSubmit={onSubmit}
			onClose={onClose}
			showCloseButton={isSetting}
			showSubmitButton={isSetting}
			showSettingButton={mode === 'update' ? false : !isSetting}
			disabled={!isSetting || mode === 'sign'}
			positionOffset={positionOffset}
			showSignature={props.showSignature}
			onSignatureClick={props.onSignatureClick}
			onSetting={onSetting}
			hide={
				isSetting
					? false
					: signPosition.sign.isSet && currentPage !== signPosition.sign.page
					? true
					: false
			}
		>
			<View css={style}>
				<Text
					category="h3"
					className={`draggableSignPositionLabel ${
						mode === 'sign' ? '' : isSetting ? '' : 'disabled'
					}`}
				>
					{mode === 'sign' ? '서명하기' : '서명 위치'}
				</Text>

				{isSetting && mode !== 'sign' && (
					<Text category="c2" className="draggableSignPositionIndicator">
						{"서명 위치를 지정하고 'V'를 클릭하세요."}
					</Text>
				)}
			</View>
		</PdfDraggableView>
	)
}

const style = css({
	width: '200px',
	height: '69.6px',

	'.draggableSignPositionLabel': {
		position: 'absolute',
		height: 'fit-content',
		top: 0,
		bottom: 0,
		margin: 'auto',
		color: deepPurple['300'],

		'&.disabled': {
			color: grey[800],
		},
	},

	'.draggableSignPositionIndicator': {
		position: 'absolute',
		bottom: '-2rem',
		color: deepPurple['A400'],
	},
})
